export const READONLY_FIELD_TYPES = {
  HEADER: 'HEADER',
  RICH_TEXT: 'RICH_TEXT',
  ECOM_CONTACT_DETAILS: 'ECOM_CONTACT_DETAILS',
  ECOM_SHIPPING_DETAILS: 'ECOM_SHIPPING_DETAILS',
  BOOKINGS_HEADER: 'BOOKINGS_HEADER',
  BOOKINGS_RICH_TEXT: 'BOOKINGS_RICH_TEXT',
  BOOKINGS_LOGIN_BAR: 'BOOKINGS_LOGIN_BAR'
};
//# sourceMappingURL=readonly-field-types.js.map